



























































































// Services
import CandidateService, {
    Candidate,
    WorkAuthorization as WAType,
} from '~/services/CandidateService';
import IntercomService from '~/services/IntercomService';
import DialogService from '~/services/DialogService';
import MessageService from '~/services/MessageService';
import CSPService, { CandidateStudyProgram } from '~/services/CSPService';

// Page Components
import PersonalDetails from './components/PersonalDetails.vue';
import ContactDetails from './components/ContactDetails.vue';
import Languages from './components/Languages.vue';
import StudyProgramModule from './components/StudyProgramModule.vue';
import Communication from './components/Communication.vue';
import WorkAuthorization from './components/WorkAuthorization.vue';
import Summary from './components/Summary.vue';
import MissingFields from './components/MissingFields.vue';

// Utils
// import deepClone from '~/utils/deepClone';
import spotlightErrorMapper from '~/utils/errors/spotlightErrorMapper';
import validateCandidateData, {
    IMissingFieldValidation,
    IProfileData,
    loadUserProfileData,
    validateProfileData,
} from '../../utils/user/validateCandidateData';

import { HAS_CHAT } from '~/router';
import CommunicationService, { EmailSettings } from '~/services/CommunicationService';
import IdentityService, { User } from '~/services/IdentityService';
import Vue, { PropType } from 'vue';
import { cloneDeep } from 'lodash';
import { VFairProfileRequirementLevel } from '~/services/VFairService';

export default Vue.extend({
    name: 'Spotlightform',
    components: {
        PersonalDetails,
        Summary,
        ContactDetails,
        Languages,
        StudyProgramModule,
        Communication,
        WorkAuthorization,
        MissingFields,
    },
    props: {
        isLoading: {
            type: Boolean,
            default: () => true,
            required: true,
        },
        requiredFields: {
            type: Object as PropType<IMissingFieldValidation>,
            required: true,
        },
        requirementLevel: {
            type: String as PropType<VFairProfileRequirementLevel>,
            default: VFairProfileRequirementLevel.Regular,
        },
    },
    data() {
        return {
            forceCandidateUpdate: false,
            identityService: new IdentityService(),
            candidateService: new CandidateService(),
            cspService: new CSPService(),
            forceUserUpdate: false,
            oldIdentity: {} as User, // The unsaved user data (firstName, nationality ... etc)
            oldCandidate: {} as Candidate,
            oldEmailSettings: {} as EmailSettings,
            oldWorkAuthorization: [] as WAType[],
            oldCandidateStudyPrograms: [] as CandidateStudyProgram[],
            profileId: null,
            profileData: {
                candidateData: {} as Candidate,
                identityData: {} as User,
                emailSettings: {} as EmailSettings,
                workAuthorization: [] as WAType[],
                terms: false,
            } as IProfileData,
            dataChanged: {
                candidate: false,
                user: false,
                workAuth: false,
                image: false,
                emailSettings: false,
                candidateStudyPrograms: false,
            },
            changedImage: null as File | null, // The image to save,
        };
    },
    computed: {
        minimal(): boolean {
            return this.requirementLevel === VFairProfileRequirementLevel.Minimum;
        },

        missingFieldValidator(): IMissingFieldValidation {
            this.$emit('validate:change', this.checkIsValid());
            return validateProfileData(this.profileData, this.requiredFields);
        },
        validator(): any {
            return validateCandidateData(
                this.profileData.identityData,
                this.profileData.candidateData
            );
        },
        shouldCreateModal(): any {
            // @ts-ignore
            return this.$interfaces.unsavedChanges.isOpen();
        },
        anyDataChanged(): boolean {
            return (
                this.dataChanged.candidate ||
                this.dataChanged.user ||
                this.dataChanged.workAuth ||
                this.dataChanged.image ||
                this.dataChanged.emailSettings ||
                this.dataChanged.candidateStudyPrograms
            );
        },
    },
    async mounted() {
        this.load();
    },
    methods: {
        async load(): Promise<void> {
            this.$emit('isLoading:change', true);
            this.profileData = await loadUserProfileData();

            this.$store.commit('profileModule/setUser', this.profileData.identityData);
            this.$store.commit('profileModule/setCandidate', this.profileData.candidateData);

            this.oldIdentity = cloneDeep(this.profileData.identityData);
            this.oldCandidate = cloneDeep(this.profileData.candidateData);
            this.oldWorkAuthorization = cloneDeep(this.profileData.workAuthorization);
            this.oldEmailSettings = cloneDeep(this.profileData.emailSettings);
            this.oldCandidateStudyPrograms = cloneDeep(this.profileData.candidateStudyPrograms);

            this.$emit('user:change', this.oldIdentity);

            const valid = this.checkIsValid();

            this.$emit('onValid', valid);
            this.$emit('isLoading:change', false);
        },
        checkIsValid(): boolean {
            const valid = validateProfileData(this.profileData, this.requiredFields);
            return Object.values(valid).every(x => x);
        },

        hasDataChanged(newData: {}, oldData: {}) {
            const a = JSON.stringify(newData);
            const b = JSON.stringify(oldData);
            return a !== b;
        },
        createOnSaveMessage(): void {
            MessageService.newMessage(
                (this.$t('general.success') as string).concat('!'),
                this.$t('spotlight.saveSuccessful')
            );
        },
        async updateEmailSettings(emailSettings: EmailSettings): Promise<EmailSettings> {
            return CommunicationService.updateEmailSettings(emailSettings).then(
                response => response
            );
        },
        setCandidateData(candidateData: Candidate): void {
            this.profileData = { ...this.profileData, candidateData: candidateData };
        },
        setIdentityData(identityData: User): void {
            this.profileData = { ...this.profileData, identityData: identityData };
        },

        async handleSave(): Promise<boolean> {
            if (!this.checkIsValid()) {
                MessageService.error(this.$t('spotlight.errors.generic.title'), null);
                return false;
            }
            this.$emit('isLoading:change', true);

            const errors: string[] = [];

            const user = this.profileData.identityData;
            const newUser: Partial<User> = {
                firstName: user.firstName,
                lastName: user.lastName,
                nationality: user.nationality,
                gender: user.gender,
                phoneNumber: user.phoneNumber,
                email: this.oldIdentity.email || user.email,
                termsConsent: this.profileData.terms,
            };
            if (!this.profileData.identityData.image) newUser.avatar = '';

            console.debug('Update chat settings');
            // Update chat settings
            if (HAS_CHAT) {
                await (this as any).$interfaces.communication.chat.user.me
                    .get()
                    .then((res: any) => {
                        (this as any).$interfaces.communication.chat.user.me.put({
                            body: {
                                displayName: user.firstName + ' ' + user.lastName,
                                title: res.data.title,
                                availableUntil: res.data.availableUntil,
                            },
                        });
                    });
            }

            const extractErrors = (err: any) =>
                Array.isArray(err) ? errors.push(...err) : errors.push(err);

            console.debug('Save user');
            // Save user
            await this.identityService.saveMe(newUser).catch(extractErrors);

            console.debug('Save user image if changed');
            // Save user image if changed
            if (this.changedImage) {
                await this.identityService.saveImage(this.changedImage).catch(extractErrors);
                this.changedImage = null;
                (this.$refs.personalDetails as any).resetChangedImage();
            }

            console.debug('Save education');

            await this.cspService.saveCandidateStudyPrograms(
                this.profileData.candidateStudyPrograms,
                this.oldCandidateStudyPrograms
            );

            console.debug('Save work authorizations');
            // Save work authorizations
            await this.candidateService
                .saveWorkAuthorizations(
                    this.profileData.workAuthorization,
                    this.oldWorkAuthorization
                )
                .catch(extractErrors);

            // Save summary
            console.debug('Save summary');
            await this.candidateService
                .saveSummary(this.profileData.candidateData.summary || '')
                .catch(extractErrors);

            // Save Me
            console.debug('Save Me');
            await this.candidateService.saveMe(this.profileData.candidateData).catch(extractErrors);

            console.debug('Save languages');
            // Save languages
            await this.candidateService
                .saveLanguages(
                    this.profileData.candidateData.languages || [],
                    this.oldCandidate.languages || []
                )
                .catch(extractErrors);

            console.debug('Update EmailSettings');
            if (this.hasDataChanged(this.profileData.emailSettings, this.oldEmailSettings)) {
                await this.updateEmailSettings(this.profileData.emailSettings).catch(extractErrors);
            }

            if (!!errors.length) {
                console.error('Errors while saving profile:', errors);
                MessageService.errorWithMapper(
                    null,
                    errors[0],
                    spotlightErrorMapper,
                    spotlightErrorMapper
                );
            } else {
                this.createOnSaveMessage();
            }

            IntercomService.setUserData();
            IntercomService.update();

            // Reload all data, to make sure we are in sync and "old<DATA>" is updated
            await this.load();
            this.$emit('isLoading:change', false);

            return !!!errors.length;
        },
    },
    watch: {
        profileData: {
            deep: true,
            handler(newProfileData: IProfileData) {
                this.dataChanged.user = this.hasDataChanged(
                    newProfileData.identityData,
                    this.oldIdentity
                );
                this.dataChanged.candidate = this.hasDataChanged(
                    newProfileData.candidateData,
                    this.oldCandidate
                );
                this.dataChanged.workAuth = this.hasDataChanged(
                    newProfileData.workAuthorization,
                    this.oldWorkAuthorization
                );
                this.dataChanged.emailSettings = this.hasDataChanged(
                    newProfileData.emailSettings,
                    this.oldEmailSettings
                );
                this.dataChanged.candidateStudyPrograms = this.hasDataChanged(
                    newProfileData.candidateStudyPrograms,
                    this.oldCandidateStudyPrograms
                );
            },
        },
        anyDataChanged(shouldShow, wasShown): void {
            const newValue = shouldShow;
            if (newValue !== wasShown) {
                // @ts-ignore
                this.$interfaces.unsavedChanges.setHasUnsavedChanges(newValue);
            }
        },
        changedImage(val): void {
            this.dataChanged.image = Boolean(val);
        },
        shouldCreateModal(shouldShow, wasShown): void {
            if (shouldShow && !wasShown) {
                DialogService.openSpotlightExitDialog(this.handleSave, this.$router);
            }
        },
    },
});
